module.exports = __webpack_public_path__ + "img/vuelogo.96e5850d.png";